import React, { Component } from "react";

export default class HeadingText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: { label: "ALL", value: 0 },
    };
  }

  render() {
    return (
      <div
        className="row wrapper border-bottom page-heading"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="col-lg-10">
          <h2>Earned Leave Carry</h2>
        </div>

        {this.props.children}
      </div>
    );
  }
}
